import { callApi } from './api';

import { SupportPlanDraftRequest } from '@/types/supportPlan';

export const updateSupportPlanDraft = async (
  supportPlanDraftID: number,
  requestBody: SupportPlanDraftRequest
) => {
  const { status, result } = await callApi<boolean>(
    `support-plan-drafts/${supportPlanDraftID}`,
    'PUT',
    undefined,
    requestBody,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
